import { render, staticRenderFns } from "./VtSwitch.vue?vue&type=template&id=2c5d5b79&"
import script from "./VtSwitch.vue?vue&type=script&lang=js&"
export * from "./VtSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports